"use client";

import { usePathname } from "next/navigation";
import Navbar from "../shared/Navbar/Navbar";
import Footer from "../shared/Footer/Footer";
import FloatingWhatsApp from "../shared/FloatingWhatsApp";
import Loader from "../loader/Loader";

/**
 * Client chrome so the root layout does not call `headers()` (which forces
 * every page into dynamic rendering and blocks ISR from API revalidate).
 */
export default function AppChrome({ children }: { children: React.ReactNode }) {
	const pathname = usePathname() || "";
	const isBookNowPage = pathname.includes("/book-now");

	return (
		<>
			{!isBookNowPage && <Loader />}
			{!isBookNowPage && <Navbar />}
			{children}
			{!isBookNowPage && <Footer />}
			{!isBookNowPage && <FloatingWhatsApp />}
		</>
	);
}
